import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=b532fa06&"
import script from "./PageForbidden.vue?vue&type=script&lang=js&"
export * from "./PageForbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports